"use client";

import { c as _c } from "react/compiler-runtime";
import ProfileNameWithAiMarker from "@/components/common/profile/ProfileNameWithAiMarker";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useCallback } from "react";
import WaveDropTime from "./time/WaveDropTime";
interface DropMinimalIdentityRowProps {
  readonly drop: ApiDrop;
}
export default function DropMinimalIdentityRow(t0) {
  const $ = _c(21);
  const {
    drop
  } = t0;
  const router = useRouter();
  const authorIdentity = drop.author.handle ?? drop.author.primary_address;
  let t1;
  if ($[0] !== router) {
    t1 = (event, path) => {
      event.preventDefault();
      event.stopPropagation();
      router.push(path);
    };
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleNavigation = t1;
  const t2 = `/${authorIdentity}`;
  let t3;
  if ($[2] !== authorIdentity || $[3] !== handleNavigation) {
    t3 = event_0 => handleNavigation(event_0, `/${authorIdentity}`);
    $[2] = authorIdentity;
    $[3] = handleNavigation;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== authorIdentity || $[6] !== drop.author.classification) {
    t4 = <ProfileNameWithAiMarker classification={drop.author.classification}>{authorIdentity}</ProfileNameWithAiMarker>;
    $[5] = authorIdentity;
    $[6] = drop.author.classification;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <Link href={t2} onClick={t3} className="tw-text-iron-200 tw-no-underline tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-opacity-80 desktop-hover:hover:tw-underline">{t4}</Link>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== authorIdentity || $[13] !== t5) {
    t6 = <p className="tw-mb-0 tw-text-sm tw-font-semibold tw-leading-none"><UserProfileTooltipWrapper user={authorIdentity}>{t5}</UserProfileTooltipWrapper></p>;
    $[12] = authorIdentity;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="tw-size-[3px] tw-flex-shrink-0 tw-rounded-full tw-bg-iron-600" />;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== drop.created_at) {
    t8 = <WaveDropTime timestamp={drop.created_at} />;
    $[16] = drop.created_at;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t8) {
    t9 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-1.5 tw-gap-y-1">{t6}{t7}{t8}</div>;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}